module.exports = __webpack_public_path__ + "images/help_v2/avatars/dragon-a6db25b932660ea3ed13e5cec789ad37.png";